import React, { useEffect, useMemo } from "react";
import "../../trends/components/Trends.module.css";
import EmptyState from "../../../components/EmptyState";
import CausesList from "../../trends/components/CausesList";
import MoodBalanceChart from "../../../shared/charts/moodBalance/MoodBalanceChart";
import { getTopMoodsPieData } from "../../../shared/charts/moodBalance/usePieChartData";
import { useTrendsView } from "../../trends/hooks/useTrendsView";
import { getLastEndedWeekKey } from "../../../utils/common/weekUtils";
import { useNavigate } from "react-router-dom";

type Props = {
  setShowWeeklyReview?: (value: boolean) => void;
};

export default function WeeklyOverview({ setShowWeeklyReview }: Props) {
  const {
    setSelectedView,
    selectedCauseView,
    setSelectedCauseView,
    selectedPeriod,
    moodCounts,
    topMoodsCauses,
    totalMoods,
    onWeekChange,
  } = useTrendsView();

  const navigate = useNavigate();
  const weeklyPieData = useMemo(
    () => getTopMoodsPieData(moodCounts, totalMoods, 2),
    [moodCounts, totalMoods]
  );

  const lastEndedWeekKey = getLastEndedWeekKey();

  useEffect(() => {
    setSelectedView("PERSONAL");
    setSelectedCauseView("GROWTH");
    setShowWeeklyReview?.(true);
    onWeekChange(lastEndedWeekKey);
  }, [
    setShowWeeklyReview,
    setSelectedCauseView,
    setSelectedView,
    onWeekChange,
    lastEndedWeekKey,
  ]);
  return (
    <div className="page-container trends-page-container">
      <div className="content-container">
        <>
          {totalMoods > 0 ? (
            <>
              <>
                <h2 className="top-causes-title">Weekly review</h2>
                <MoodBalanceChart
                  balancePieData={weeklyPieData}
                  totalMoods={totalMoods}
                />
              </>
            </>
          ) : (
            <>
              <EmptyState title="No mood data available" />
            </>
          )}

          <div
            className="legend-container"
            style={{
              marginTop: "20px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              justifyContent: "center",
              gap: "16px",
              width: "100%",
              backgroundColor: "#f9f9ff",
              border: "0.5px solid #ccc",
              borderRadius: "8px",

              alignItems: "center",
              padding: "10px 14px",
            }}
          >
            <div
              className="legend-item"
              style={{
                gap: "8px",
                //borderRight: "1px solid",
                whiteSpace: "nowrap",
              }}
            >
              <div
                className="legend-color"
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "4px",
                  flexShrink: 0,
                }}
              />
              <span className="legend-text" style={{ whiteSpace: "nowrap" }}>
                <span className="legend-label" style={{ fontWeight: "bold" }}>
                  You
                </span>{" "}
                <br />
                <br />
                <span className="legend-percentage">Balance → Challenge</span>
              </span>
            </div>

            <div
              className="legend-item"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                whiteSpace: "nowrap",
              }}
            >
              <div
                className="legend-color"
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "4px",
                  flexShrink: 0,
                }}
              />
              <span className="legend-text" style={{ whiteSpace: "nowrap" }}>
                <span className="legend-label" style={{ fontWeight: "bold" }}>
                  Team
                </span>{" "}
                <br />
                <br />
                <span className="legend-percentage">Challenge ↓</span>
              </span>
            </div>
          </div>

          {Object.keys(topMoodsCauses || {}).length > 0 && (
            <CausesList filteredCauses={topMoodsCauses} />
          )}
          <div className="causes-list">
            <div className="cause-item">
              {/* Cause name */}
              <span className="cause-name">Study new (team challenge)</span>

              {/* Count as a badge */}
              <span className="cause-badge">1</span>
            </div>
          </div>
        </>
      </div>
      <button
        className="proceed-button"
        onClick={() => {
          navigate("/app/home");
        }}
      >
        Proceed
      </button>
    </div>
  );
}
